import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/api/hooks/useAuth";

interface RequireAuthProps {
  children: React.ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { isLoading, isAuthenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      const returnUrl = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?return=${returnUrl}`, { replace: true });
    }
  }, [isLoading, isAuthenticated, location.pathname, location.search, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg-body">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-copper border-t-transparent mx-auto" />
          <p className="mt-4 text-sm text-text-muted">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg-body">
        <p className="text-sm text-text-muted">Redirecting to login...</p>
      </div>
    );
  }

  return <>{children}</>;
}
